import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return <div className="page-container"><section className="card flex min-h-[28rem] flex-col items-center justify-center p-8 text-center"><p className="text-sm font-semibold text-primary">404</p><h1 className="mt-2 text-2xl font-bold">内容不存在或已删除</h1><p className="mt-2 max-w-md text-sm leading-relaxed text-muted">这个地址无法打开。内容可能已经移到回收站，也可能链接不完整。</p><Link className="btn-primary mt-6" to="/dashboard"><ArrowLeft size={17} />返回首页</Link></section></div>;
}
